import React, {useMemo, useState} from 'react';

import createCtx from 'coreUtils/createCtx';

import {IMainNavigationContext, MainNavigationProviderProps} from './IMainNavigationContext';

export const [useMainNavigationContext, MainNavigationContextProvider] = createCtx<IMainNavigationContext>();

export const MainNavigationProvider = ({
	children,
}: MainNavigationProviderProps) => {
	const [activeLink, setActiveLink] = useState<string | null>(null);
	const [activeCategoryLabel, setActiveCategoryLabel] = useState<string | null>(null);

	const value = useMemo(() => ({
		activeLink,
		activeCategoryLabel,
		setActiveLink,
		setActiveCategoryLabel
	}), [activeLink, activeCategoryLabel]);

	return (
		<MainNavigationContextProvider value={value}>
			{children}
		</MainNavigationContextProvider>
	);
};
